import DataSubjectAccessRequestAssociationService from '../services/dsar-association-service';

export const dataSubjectAccessRequestAssociation = {
  namespaced: true,
  state: {
    associations: null,
    association: null,
    dsarAssociationsSummary: [],
  },
  actions: {
    newAssociation({ commit }, dsarId) {
      const template = {};
      const empty = JSON.parse(JSON.stringify(template));
      if (typeof dsarId === 'object') {
        empty.dsarId = dsarId.dsarId;
      } else {
        empty.dsarId = dsarId;
      }
      commit('setAssociation', empty);
    },
    listAssociations({ commit }, dsarId) {
      commit('setIsBusy', true, { root: true });
      return DataSubjectAccessRequestAssociationService.list(dsarId)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setAssociations', result.model);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    createAssociation({ commit }, data) {
      commit('setIsBusy', true, { root: true });
      return DataSubjectAccessRequestAssociationService.create(data)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          const { message } = result;
          return Promise.resolve(message);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    getAssociation({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      commit('setAssociation', null);
      return DataSubjectAccessRequestAssociationService.get(
        payload.dsarId,
        payload.dsarAssociationId,
      ).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setAssociation', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    updateAssociation({ commit }, data) {
      commit('setIsBusy', true, { root: true });
      return DataSubjectAccessRequestAssociationService.update(data)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          const { message } = result;
          return Promise.resolve(message);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    deleteAssociation({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return DataSubjectAccessRequestAssociationService.delete(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          const { message } = result;
          return Promise.resolve(message);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
  },
  mutations: {
    setAssociations(state, newAssociations) {
      state.associations = newAssociations;
    },
    setAssociation(state, newAssociation) {
      state.association = newAssociation;
    },
    setDisputeAssociationsSummary(state, newDisputeAssociationsSummary) {
      state.disputeAssociationsSummary = newDisputeAssociationsSummary;
    },
    clearDisputeAssociationsSummary(state) {
      state.disputeAssociationsSummary = [];
    },
  },
};
